import { MethodType } from '../constants/MethodType'
const api = require('./api')

export const fetchUserList = (params) => api.request(1, '/users', MethodType.GET, params)

export const fetchUser = (id, params) => api.request(1, `/users/${id}`, MethodType.GET, params)

export const addUser = params => api.request(1, '/users', MethodType.POST, params)

export const modifyUser = (id, params) => api.request(1, `/users/${id}`, MethodType.PATCH, params)

export const deleteUser = (id, params) => api.request(1, `/users/${id}`, MethodType.DELETE, params)
